<h1>HOME PAGE</h1>
<div class="dialog-close-button" (click)="onNoClick()">X</div>
